function NotarySpecialization() {
    
  const items = [
    { icon: 'fas fa-hand-point-right', label: 'General Notary' },
    { icon: 'fas fa-hand-point-right', label: 'Buyer and Seller Notary' },
    { icon: 'fas fa-hand-point-right', label: 'Loan Signing' },
    { icon: 'fas fa-hand-point-right', label: 'Will and Trust Signing' },
    { icon: 'fas fa-hand-point-right', label: 'Marriage Witness - Notary' },
    {
      icon: 'fas fa-hand-point-right',
      label: 'Florida Young Adult Legal Documents Package',
      subItems: [
        'Durable Financial Power of Attorney',
        'Designation of Health Care Surrogate',
        'HIPAA Authorization',
        'Living Will',
        'FERPA Authorization',
        'Simple Last Will and Testament',
        'Anatomical Gift Declaration',
        'Digital Assets Authorization',
        'Emergency Information Sheet',
        'Signing & Notary',
      ],
    },
  ];

  return (
    <div className="tp-service-specialization mb-40">
      <h5 className="mb-10">We are specialized in</h5>
      <ul className="tp-service-list">
        {items.map((item, index) => (
          <li key={index}>
            {item.icon && <i className={`${item.icon} mr-5`}></i>}
            {item.label && <strong>{item.label}</strong>}
            {item.subItems && (
              <ul className="tp-service-sublist mt-5 ml-25">
                {item.subItems.map((subItem, subIndex) => (
                  <li key={subIndex}>{subItem}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default NotarySpecialization;
